import Vue from 'vue';
import Raven from 'raven-js';
import RavenVue from 'raven-js/plugins/vue';

export default function() {
  if (!!FRONT_SENTRY_DNS && !!FRONT_SENTRY_RELEASE) {
    const tags = {
      theme: 'default',
      cell: window.APP_DATA.application_cell,
      app: 'entrance',
    };

    Raven.config(FRONT_SENTRY_DNS, {
      release: FRONT_SENTRY_RELEASE,
      environment: window.APP_DATA.environment,
      tags,
    })
      .addPlugin(RavenVue, Vue)
      .install();
  }
}
